import styled from 'styled-components';

export default styled.div`
  box-sizing: border-box;
  display: flex;
  height: calc(100vh - ${({ hasNews }) => hasNews ? '94px' : '64px'});
  padding: 0;
  position: relative;
`;
